export default __webpack_public_path__ + "static/media/project2.4a977aee.png";